import { useState } from 'react';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { CircularProgress, Fab } from '@mui/material';

import './ButtonLoadNextPage.scss';

interface ButtonLoadNextPageProps {
  rowsPerPage: number;
  hasMoreData: boolean;
  isLoadingMoreData: boolean;
  onLoadNextPage: Function;
}
function ButtonLoadNextPage({
  rowsPerPage,
  hasMoreData,
  isLoadingMoreData,
  onLoadNextPage,
}: ButtonLoadNextPageProps) {
  const [page, setPage] = useState(0);

  const nextPage = () => {
    onLoadNextPage((page + 1) * rowsPerPage);
    setPage(page + 1);
  };

  if (hasMoreData || page > 0) {
    return (
      <Fab
        className="button-load-next-page"
        color="primary"
        sx={{
          position: 'absolute',
          bottom: 16,
          right: 16,
        }}
        onClick={() => nextPage()}
        disabled={!hasMoreData}
      >
        {
          isLoadingMoreData === false
            ? <KeyboardArrowDownIcon />
            : <CircularProgress size={30} disableShrink color="secondary" />
        }
      </Fab>
    );
  }
  return (null);
}

export default ButtonLoadNextPage;
